import { MouseEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Spinner } from "react-bootstrap";
import { useQueryClient } from "react-query";
import { mdiChevronRight, mdiTrashCanOutline } from "@mdi/js";
import Icon from "@mdi/react";

import { useToast } from "src/context/ToastContext";
import { CriteriaEntityGetResponse } from "src/entities/CriteriaEntity";
import CriteriaService, { criteriaQueryKeys } from "src/services/CriteriaService";

import ListCard from "../ListCard";

const criteriaService = new CriteriaService();

type CriterioCardProps =
	| { skeleton: true; data?: never }
	| { skeleton?: never; data: CriteriaEntityGetResponse };

const toastTitle = "Critério";

export default function CriterioCard(props: CriterioCardProps) {
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { handleToast } = useToast();

	const [removeModal, setRemoveModal] = useState(false);
	const [removeLoadingModal, setRemoveLoadingModal] = useState(false);
	const [removed, setRemoved] = useState(false);

	function handleClick() {
		if (!props.skeleton && props.data) {
			navigate("/criterioFormulario/" + props.data.id);
		}
	}

	function handleClickRemove(e: MouseEvent<HTMLButtonElement>) {
		e.stopPropagation();
		setRemoveModal(true);
	}

	async function handleRemove() {
		if (!props.skeleton && props.data) {
			setRemoveLoadingModal(true);
			let resp = await criteriaService.delete(props.data.id!);
			if (resp.status === 204) {
				queryClient.invalidateQueries(criteriaQueryKeys.list);
				setRemoved(true);
			} else {
				handleToast(toastTitle, resp.statusText, 5000, "danger");
			}
			setRemoveModal(false);
			setRemoveLoadingModal(false);
		}
	}

	function handleCloseModal() {
		if (!removeLoadingModal) {
			setRemoveModal(false);
		}
	}

	const skeletonButton = props.skeleton ? "skeleton skeleton-button" : "";

	return !removed ? (
		<>
			<ListCard onClick={handleClick}>
				<ListCard.Content>
					<ListCard.Item>
						<ListCard.Title skeleton={props.skeleton}>Nome</ListCard.Title>
						<ListCard.Text skeleton={props.skeleton}>{props.data?.title ?? "..."}</ListCard.Text>
					</ListCard.Item>
				</ListCard.Content>
				<ListCard.Action>
					<Button variant="light" className={`me-2 ${skeletonButton}`} onClick={handleClickRemove}>
						<Icon path={mdiTrashCanOutline} size={1} className="text-danger" />
					</Button>
					<Icon path={mdiChevronRight} size={1} className={`text-muted m-2 ${skeletonButton}`} />
				</ListCard.Action>
			</ListCard>

			<Modal show={removeModal} onHide={handleCloseModal} centered>
				<Modal.Header closeButton>
					<Modal.Title>Remover Critério</Modal.Title>
				</Modal.Header>
				<Modal.Body className="text-center">{!removeLoadingModal ? "Deseja realmente remover este critério?" : <Spinner />}</Modal.Body>
				{!removeLoadingModal && (
					<Modal.Footer>
						<Button variant="secondary" onClick={handleCloseModal}>
							Cancelar
						</Button>
						<Button variant="danger" onClick={handleRemove}>
							Remover
						</Button>
					</Modal.Footer>
				)}
			</Modal>
		</>
	) : null;
}
